document.addEventListener('DOMContentLoaded', () => {

    if (!document.querySelector('input[data-monogram-variant-id]')) return;

    const monogramFeeVariantId = document.querySelector('input[data-monogram-variant-id]')?.value;
    const monogramLineItemKey = document.querySelector('[data-monogram-key]')?.dataset.monogramKey;

    // Listen for clicks on remove links
    document.querySelectorAll('.cart-item__remove').forEach(removeLink => {

        removeLink.addEventListener('click', async (event) => {
            event.preventDefault();

            // Extract line number from the remove link's href, e.g. /cart/change?line=2&quantity=0
            const href = removeLink.getAttribute('href');
            if (!href) return;

            // const urlParams = new URLSearchParams(href.split('?')[1]);
            // const itemToRemove = urlParams.get('id');
            // if (!itemToRemove) return;

            // Find the cart line item element by matching the line number attribute
            // Alternatively, find the hidden input by variant id or other attrs
            const lineItemElement = removeLink.closest('.cart-item');
            if (!lineItemElement) return;

            // Get product to remove
            const itemToRemove = lineItemElement.querySelector('[data-key]')?.dataset.key;

            // Get monogram letter count from the hidden input within this line item
            const monogramLetters = parseInt(lineItemElement.querySelector('input[data-monogram-letters]')?.dataset.monogramLetters || '0', 10);

            try {
                // Fetch current cart to find monogram product item and quantities
                const cart = await fetch('/cart.js').then(res => res.json());

                // Find Monogram Fee line number in cart (line numbers start at 1)
                let monogramLineNumber = null;
                let monogramQty = 0;
                cart.items.forEach((item, index) => {
                    if (item.variant_id == monogramFeeVariantId) {
                        monogramLineNumber = index + 1;
                        monogramQty = item.quantity;
                    }
                });

                // Prepare updates object
                // Set the removed product quantity to 0
                const updates = {};
                updates[itemToRemove] = 0;

                // console.log(updates);

                // If monogram fee product found and monogram letters > 0, adjust quantity
                if (monogramLineItemKey && monogramLetters > 0) {
                    let newMonogramQty = monogramQty - monogramLetters;
                    if (newMonogramQty < 0) newMonogramQty = 0;
                    updates[monogramLineItemKey] = newMonogramQty;
                }

                // console.log(updates);

                // Send update request with all changes at once
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                });

                console.log('Successfully updated cart');

                // Reload page to reflect cart changes
                window.location.reload();
            } catch(err) {
                console.error(err);
            }
        });
    });
});
